const formElements = (() => {

    const initBlock = (form) => {
        handleConditionalFields(form);
        handleClearInput(form);
    };

    const handleConditionalFields = (form) => {
        form.querySelectorAll('.form-group--conditional').forEach(el => {
            const target = el.dataset.conditionalTarget;
            const value = el.dataset.conditionalValue;
            const targetElement = form.querySelector('.form-group__form-control[name="' + target + '"]');
            targetElement.addEventListener('change', () => {
                el.classList.add('form-group--conditional--hidden');
                if (targetElement.value === value){
                    el.classList.remove('form-group--conditional--hidden');
                }
            });
        });
    };
    
    const handleClearInput = (form) => {
        form.querySelectorAll('.form-group').forEach(formGroup => {
            const clear = formGroup.querySelector('button[data-clear]');
            if (clear){
                const input = formGroup.querySelector('input');
                if (input){
                    input.addEventListener('input', () => {
                        if (input.value.length > 0){
                            clear.classList.remove('hidden');
                        }else{
                            clear.classList.add('hidden');
                        }
                    });
                    clear.addEventListener('click', () => {
                        input.value = '';
                        clear.classList.add('hidden');
                        const dropdown = formGroup.querySelector('[data-dropdown]');
                        if (dropdown){
                            dropdown.classList.remove('form-group__dropdown--open');                            
                        }
                    });                    
                }                
            }            
        });        
    }

    return {initBlock};

})();

ControlBinders.register(`form`, form => formElements.initBlock(form));